import httpServiceAuth from '@/services/http-service';
import { apiEndpoints } from '@/services/constants';
import { errorHandler } from '@/services/error-handler';

export default {
  state: {
    usage: null,
  },
  mutations: {
    setUsage(state, payload) {
      state.usage = payload;
    },
  },
  actions: {
    getUsage({ commit }) {
      commit('loader/setScreenLoading', true, { root: true });
      return httpServiceAuth
        .get(`${apiEndpoints.master.usage}`)
        .then((response) => {
          commit('setUsage', response.data.data);
        })
        .catch((error) => {
          if (error.response) {
            errorHandler(error.response);
          }
        })
        .finally(() => {
          commit('loader/setScreenLoading', false, { root: true });
        });
    },
  },
};
